import * as React from 'react'

import { observer } from 'mobx-react'

import { Button } from '~/client/src/shared/components/shadcn-ui/button'

// localization: translated

interface IProps {
  isDisabled?: boolean
  section: ISavedFiltersSection
}

export interface ISavedFiltersSection {
  getLabel: () => string
  icon: JSX.Element
  onClick: () => void
  isDisabled?: boolean
}

@observer
export default class SectionButton extends React.Component<IProps> {
  public render() {
    const {
      section: { onClick, getLabel, icon },
    } = this.props
    return (
      <Button variant="ghost" disabled={this.isDisabled} onClick={onClick}>
        {icon}
        {getLabel()}
      </Button>
    )
  }

  private get isDisabled(): boolean {
    const { isDisabled, section } = this.props
    return isDisabled || section.isDisabled
  }
}
